module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/4_4571c4940fe7099bb2e039c24739e562.png";